module.exports = __webpack_public_path__ + "static/media/id-flag-small.1fcd01c9.svg";